import { ReactElement } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../components/Shared/Sidebar";
import Spinner from "../../../components/Shared/Spinner";
import { useDependency } from "../../../contexts/DependencyContext";
import { useRecurrentAsyncCall } from "../../../hooks/UseAsyncCall";
import { IComponent } from "../../../services/http/component/models/IComponent";
import styles from "./MapSidebar.module.scss";
import { ComponentModelService } from "../../../services/ComponentModelService";
import { IComponentInfoResult } from "../../../services/http/component/models/IComponentInfoResult";
import SidebarWidget from "../../../components/Shared/Sidebar/SidebarWidget";

interface MapSidebarProps
{
    component: IComponent;
    close: () => void;
}

async function loadModelData(service: ComponentModelService, componentId: string): Promise<IComponentInfoResult>
{
    return await service.loadComponentModel(componentId.toString(), undefined!);
}

const MapSidebar = (props: MapSidebarProps): ReactElement =>
{
    const componentModelService = useDependency(ComponentModelService);
    const modelContent = useRecurrentAsyncCall(parseInt(process.env.REACT_APP_CHART_REFRESH_RATE ?? "300000"), loadModelData, componentModelService, props.component.id);

    const SidebarHeader = (): ReactElement =>
    {
        return (
            <span>{props.component.name}</span>
        );
    };

    const SidebarFooter = (): ReactElement =>
    {
        return (
            <Link to={`/dashboard/${props.component.id}`} className="btn btn-info-light">
                Review in dashboard
                <i className="material-icons">arrow_forward</i>
            </Link>
        );
    }

    return (
        <Sidebar
            customClassName={[styles.sidePanel, props.component ? styles.visible : ""].join(" ")}
            header={<SidebarHeader />}
            footer={<SidebarFooter />}
            close={props.close}
            collapsible={true}
        >
            {modelContent.loading && <Spinner caption="Loading..." />}
            {!modelContent.loading && modelContent.content && (<>
                {modelContent.content.widgets.map((widget, index) => {
                    const configuration = JSON.parse(widget.uiConfiguration);
                    return (
                        <SidebarWidget
                            widget={widget}
                            index={index}
                            key={index}
                            visualClasses={configuration.visualClasses}
                        />
                    )
                })}
            </>)}
        </Sidebar>
    );
};

export default MapSidebar;
